import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FileText, AlertCircle, CheckCircle, XCircle } from 'lucide-react';

export const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-rose-50">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16">
        <div className="container max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm border border-amber-200 rounded-full px-4 py-2 mb-6">
            <FileText className="h-4 w-4 text-amber-600" />
            <span className="body-small text-amber-800 font-mono uppercase tracking-wider">
              Syarat & Ketentuan
            </span>
          </div>
          
          <h1 className="heading-hero mb-6">
            Ketentuan Penggunaan<br />
            Desy Clare
          </h1>
          
          <p className="body-large text-gray-600 mb-8 max-w-2xl mx-auto">
            Syarat dan ketentuan yang mengatur penggunaan platform numerologi Desy Clare
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="pb-16">
        <div className="container max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8 md:p-12">
            
            {/* Last Updated */}
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-8">
              <p className="body-small text-amber-800">
                <strong>Terakhir diperbarui:</strong> Oktober 2025
              </p>
            </div>

            {/* Agreement */}
            <div className="mb-10">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                  <CheckCircle className="h-4 w-4 text-blue-600" />
                </div>
                <h2 className="heading-2">Persetujuan Penggunaan</h2>
              </div>
              <p className="body-medium text-gray-700 ml-11">
                Dengan mengakses dan menggunakan platform Desy Clare, Anda setuju untuk 
                terikat dengan ketentuan penggunaan ini. Jika Anda tidak setuju dengan 
                ketentuan ini, mohon tidak menggunakan layanan kami.
              </p>
            </div>

            {/* Services Description */}
            <div className="mb-10">
              <h3 className="heading-3 mb-4">Deskripsi Layanan</h3>
              <div className="space-y-4">
                <p className="body-medium text-gray-700">
                  Kami menyediakan layanan analisis numerologi untuk tujuan 
                  pengembangan diri dan pemahaman kepribadian. Layanan ini meliputi:
                </p>
                <ul className="space-y-2 ml-6">
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-amber-500 rounded-full mt-2"></div>
                    <span className="body-medium text-gray-700">
                      Analisis karakter dan kepribadian berdasarkan tanggal lahir
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-amber-500 rounded-full mt-2"></div>
                    <span className="body-medium text-gray-700">
                      Analisis potensi positif dan negatif dari kepribadian dan potensi diri
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-amber-500 rounded-full mt-2"></div>
                    <span className="body-medium text-gray-700">
                      Panduan karir dan bisnis berdasarkan profil numerologi
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* User Responsibilities */}
            <div className="mb-10">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                  <CheckCircle className="h-4 w-4 text-green-600" />
                </div>
                <h3 className="heading-3">Tanggung Jawab Pengguna</h3>
              </div>
              
              <div className="ml-11 space-y-4">
                <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                  <h4 className="font-semibold text-green-800 mb-2">Yang Harus Dilakukan:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-start gap-2">
                      <CheckCircle className="h-4 w-4 text-green-600 mt-0.5" />
                      <span className="body-small text-green-700">
                        Memberikan informasi yang akurat dan jujur
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <CheckCircle className="h-4 w-4 text-green-600 mt-0.5" />
                      <span className="body-small text-green-700">
                        Menggunakan layanan untuk tujuan pengembangan diri yang positif
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <CheckCircle className="h-4 w-4 text-green-600 mt-0.5" />
                      <span className="body-small text-green-700">
                        Menghormati hak kekayaan intelektual kami
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Prohibited Uses */}
            <div className="mb-10">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
                  <XCircle className="h-4 w-4 text-red-600" />
                </div>
                <h3 className="heading-3">Penggunaan yang Dilarang</h3>
              </div>
              
              <div className="ml-11">
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                  <h4 className="font-semibold text-red-800 mb-2">Yang Tidak Boleh Dilakukan:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-start gap-2">
                      <XCircle className="h-4 w-4 text-red-600 mt-0.5" />
                      <span className="body-small text-red-700">
                        Menyalahgunakan atau mendistribusikan ulang konten tanpa izin
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <XCircle className="h-4 w-4 text-red-600 mt-0.5" />
                      <span className="body-small text-red-700">
                        Menggunakan layanan untuk tujuan ilegal atau merugikan
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <XCircle className="h-4 w-4 text-red-600 mt-0.5" />
                      <span className="body-small text-red-700">
                        Mengganggu atau merusak sistem dan keamanan platform
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Disclaimer */}
            <div className="mb-10">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center">
                  <AlertCircle className="h-4 w-4 text-yellow-600" />
                </div>
                <h3 className="heading-3">Disclaimer Penting</h3>
              </div>
              
              <div className="ml-11 bg-yellow-50 border border-yellow-200 rounded-lg p-6">
                <p className="body-medium text-yellow-800 mb-3">
                  <strong>Tujuan Pengembangan Diri:</strong>
                </p>
                <p className="body-medium text-yellow-700 mb-4">
                  Layanan numerologi pada desyclare.com ini ditujukan untuk pengembangan diri, refleksi 
                  spiritual, dan pemahaman kepribadian. Hasil analisis tidak dimaksudkan 
                  sebagai:
                </p>
                <ul className="space-y-1">
                  <li className="body-small text-yellow-700">• Pengganti nasihat medis atau psikologis profesional</li>
                  <li className="body-small text-yellow-700">• Prediksi masa depan yang pasti</li>
                  <li className="body-small text-yellow-700">• Keputusan finansial atau bisnis</li>
                  <li className="body-small text-yellow-700">• Panduan untuk keputusan hidup yang krusial</li>
                </ul>
              </div>
            </div>

            {/* Intellectual Property */}
            <div className="mb-10">
              <h3 className="heading-3 mb-4">Hak Kekayaan Intelektual</h3>
              <p className="body-medium text-gray-700 mb-4">
                Semua konten, termasuk tetapi tidak terbatas pada teks, grafik, logo, 
                ikon, gambar, dan perangkat lunak dalam platform ini adalah 
                eksklusif milik kami dan dilindungi oleh hukum hak cipta Indonesia dan internasional.
              </p>
            </div>

            {/* Limitation of Liability */}
            <div className="mb-10">
              <h3 className="heading-3 mb-4">Batasan Tanggung Jawab</h3>
              <p className="body-medium text-gray-700">
                Kami tidak bertanggung jawab atas kerugian langsung, tidak langsung, 
                insidental, atau konsekuensial yang timbul dari penggunaan layanan kami. 
                Pengguna bertanggung jawab penuh atas interpretasi dan penerapan hasil 
                analisis numerologi.
              </p>
            </div>

            {/* Changes to Terms */}
            <div className="mb-10">
              <h3 className="heading-3 mb-4">Perubahan Ketentuan</h3>
              <p className="body-medium text-gray-700">
                Kami berhak mengubah ketentuan penggunaan ini sewaktu-waktu. Pengguna diharapkan
                untuk meninjau ketentuan ini secara berkala. 
                Penggunaan berkelanjutan setelah perubahan berarti Anda menyetujui 
                ketentuan yang diperbarui.
              </p>
            </div>

            {/* Contact Information */}
            <div className="bg-gradient-to-r from-amber-50 to-rose-50 rounded-xl p-8">
              <h3 className="heading-3 mb-4">Kontak & Pertanyaan</h3>
              <p className="body-medium text-gray-700 mb-4">
                Jika Anda memiliki pertanyaan tentang ketentuan penggunaan ini, 
                silakan hubungi kami:
              </p>
              <div className="space-y-2">
                <p className="body-medium text-gray-700">
                  <strong>Email:</strong> desyclare@gmail.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsOfService;